import { cva } from 'class-variance-authority'

export const styles = cva(
  `
   flex
   min-h-[80px]
   w-full
   rounded-md
   border
   border-input
   border-neutral-200
   bg-transparent
   py-2
   px-4
   text-base
   shadow-sm
   transition-colors
   placeholder:text-muted-foreground
   focus-visible:outline-none
   focus-visible:border-neutral-400
   focus-visible:border-1
   disabled:cursor-not-allowed
   disabled:opacity-50
   disabled:bg-disabled
   md:text-sm
  `,
  {
    variants: {
      error: {
        true: `
          placeholder:text-neutral-400
          placeholder:body-sm
          border-2
          border-danger-50
        `,
      },
    },
    defaultVariants: {
      error: false,
    },
  }
)
